import { render, staticRenderFns } from "./MoveLobbyShoe.vue?vue&type=template&id=45e9a7aa&"
import script from "./MoveLobbyShoe.vue?vue&type=script&lang=js&"
export * from "./MoveLobbyShoe.vue?vue&type=script&lang=js&"
import style0 from "./MoveLobbyShoe.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MoveLobbyShoe.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports